(() => {
  const SECTION_SELECTOR = '.oddit-section-skin-concern-selector';
  const ACTIVE_CLASS = 'oddit-section-skin-concern-selector__tab--active';
  const HERO_CAROUSEL_SELECTOR = '.oddit-section-concern-hero__carousel';

  function setActive(tab, active) {
    if (tab.tagName === 'A') return;
    tab.classList.toggle(ACTIVE_CLASS, active);
    tab.setAttribute('aria-pressed', String(active));
    tab.style.backgroundColor = active ? tab.dataset.activeColor || '' : '';
  }

  // Sticky sections pin below the sticky header and get a bottom border once pinned.
  function initStuckWatcher(section) {
    if (section.dataset.sticky === undefined) return;
    const wrapper = section.closest('.shopify-section') || section.parentElement;
    if (!wrapper) return;
    // .header-section is the sticky element; its height includes the sub nav bar.
    const header = document.querySelector('.header-section, .site-header');

    let stuckObserver;
    const sync = () => {
      const offset = header ? Math.round(header.getBoundingClientRect().height) : 0;
      wrapper.style.setProperty('--skin-concern-sticky-offset', `${offset}px`);
      stuckObserver?.disconnect();
      stuckObserver = new IntersectionObserver(
        ([entry]) => section.classList.toggle('oddit-section-skin-concern-selector--stuck', entry.intersectionRatio < 1),
        { threshold: [1], rootMargin: `-${offset + 1}px 0px 0px 0px` }
      );
      stuckObserver.observe(wrapper);
    };

    if (header) new ResizeObserver(sync).observe(header);
    else sync();
  }

  // concernNumber 0 = no tab selected: show [data-concern-default], and for
  // sections without a default sibling (callouts, etc.) keep variant 1 visible.
  // Otherwise show only the matching data-concern-variant.
  function showVariants(concernNumber) {
    const isDefault = concernNumber === 0;

    for (const el of document.querySelectorAll('[data-concern-default]')) {
      el.style.display = isDefault ? '' : 'none';
    }

    for (const el of document.querySelectorAll('[data-concern-variant]')) {
      const variant = Number(el.dataset.concernVariant);
      if (isDefault) {
        const parentHasDefault = Boolean(el.parentElement?.querySelector('[data-concern-default]'));
        el.style.display = parentHasDefault ? 'none' : variant === 1 ? '' : 'none';
      } else {
        el.style.display = variant === concernNumber ? '' : 'none';
      }
    }
  }

  // When the visitor picks a concern, jump the hero image carousel to the
  // matching slide (if any) and stop autoplay so it doesn't keep cycling away.
  // Images still free-run until the first manual tab click.
  function syncHeroSlide(index) {
    const carousel = document.querySelector(HERO_CAROUSEL_SELECTOR);
    const swiper = carousel?.swiper;
    if (!swiper || typeof index !== 'number' || Number.isNaN(index)) return;

    const slideCount = swiper.slides?.length || 0;
    if (slideCount < 1) return;

    const target = ((index % slideCount) + slideCount) % slideCount;
    if (typeof swiper.slideToLoop === 'function' && swiper.params?.loop) {
      swiper.slideToLoop(target);
    } else {
      swiper.slideTo(target);
    }
    swiper.autoplay?.stop?.();
  }

  function initSection(section) {
    if (section.dataset.concernTabsReady === 'true') return;
    section.dataset.concernTabsReady = 'true';

    const tabs = [...section.querySelectorAll('.oddit-section-skin-concern-selector__tab')];
    if (!tabs.length) return;

    let activeIndex = -1;

    function showDefault() {
      activeIndex = -1;
      tabs.forEach((tab) => setActive(tab, false));
      showVariants(0);
      document.dispatchEvent(
        new CustomEvent('oddit:concern-changed', {
          detail: { index: -1, concernNumber: 0 },
        })
      );
    }

    function activate(index, { syncHero } = {}) {
      if (typeof index !== 'number' || Number.isNaN(index) || index < 0) return;
      const safeIndex = Math.min(index, tabs.length - 1);

      activeIndex = safeIndex;
      tabs.forEach((tab, i) => setActive(tab, i === safeIndex));
      showVariants(safeIndex + 1);

      document.dispatchEvent(
        new CustomEvent('oddit:concern-changed', {
          detail: { index: safeIndex, concernNumber: safeIndex + 1 },
        })
      );

      if (syncHero) syncHeroSlide(safeIndex);
    }

    tabs.forEach((tab, i) => {
      // Linked tabs navigate to another page; leave content-swap to buttons only.
      if (tab.tagName === 'A') return;

      tab.addEventListener('click', () => {
        // Clicking the active tab again clears it and restores Default Text.
        if (activeIndex === i) {
          showDefault();
          return;
        }
        activate(i, { syncHero: true });
      });
    });

    // No tab selected on load — hero Default Text shows; carousel keeps autoplaying.
    showDefault();

    initStuckWatcher(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      delete section.dataset.concernTabsReady;
      initSection(section);
    }
  });
})();
